(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6532],{

/***/ 12666:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.ts
var src_exports = {};
__export(src_exports, {
  useCallbackRef: () => useCallbackRef
});
module.exports = __toCommonJS(src_exports);
var import_react = __webpack_require__(67294);
function useCallbackRef(callback, deps = []) {
  const callbackRef = (0, import_react.useRef)(callback);
  (0, import_react.useEffect)(() => {
    callbackRef.current = callback;
  });
  return (0, import_react.useCallback)((...args) => {
    var _a;
    return (_a = callbackRef.current) == null ? void 0 : _a.call(callbackRef, ...args);
  }, deps);
}
// Annotate the CommonJS export names for ESM import in node:
0 && (0);


/***/ }),

/***/ 20837:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.ts
var src_exports = {};
__export(src_exports, {
  useControllableProp: () => useControllableProp,
  useControllableState: () => useControllableState
});
module.exports = __toCommonJS(src_exports);
var import_react = __webpack_require__(67294);
var import_react_use_callback_ref = __webpack_require__(12666);
function useControllableProp(prop, state) {
  const controlled = typeof prop !== "undefined";
  const value = controlled ? prop : state;
  return (0, import_react.useMemo)(() => [controlled, value], [controlled, value]);
}
function useControllableState(props) {
  const {
    value: valueProp,
    defaultValue,
    onChange,
    shouldUpdate = (prev, next) => prev !== next
  } = props;
  const onChangeProp = (0, import_react_use_callback_ref.useCallbackRef)(onChange);
  const shouldUpdateProp = (0, import_react_use_callback_ref.useCallbackRef)(shouldUpdate);
  const [uncontrolledState, setUncontrolledState] = (0, import_react.useState)(defaultValue);
  const controlled = valueProp !== void 0;
  const value = controlled ? valueProp : uncontrolledState;
  const setValue = (0, import_react_use_callback_ref.useCallbackRef)(
    (next) => {
      const setter = next;
      const nextValue = typeof next === "function" ? setter(value) : next;
      if (!shouldUpdateProp(value, nextValue)) {
        return;
      }
      if (!controlled) {
        setUncontrolledState(nextValue);
      }
      onChangeProp(nextValue);
    },
    [controlled, onChangeProp, value, shouldUpdateProp]
  );
  return [value, setValue];
}
// Annotate the CommonJS export names for ESM import in node:
0 && (0);


/***/ }),

/***/ 41087:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/forgot-email-address",
      function () {
        return __webpack_require__(21964);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 21964:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* reexport */ ForgotEmailAddress_bs_make; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/rescript-classnames/src/Cn.bs.js
var Cn_bs = __webpack_require__(20859);
// EXTERNAL MODULE: ./src/common/util.bs.js
var util_bs = __webpack_require__(7667);
// EXTERNAL MODULE: ./node_modules/@rescript/std/lib/es6/curry.js
var curry = __webpack_require__(92592);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/library/Button.bs.js
var Button_bs = __webpack_require__(59037);
// EXTERNAL MODULE: ./node_modules/@rescript/std/lib/es6/js_promise.js
var js_promise = __webpack_require__(27097);
// EXTERNAL MODULE: ./src/components/forms/PhoneField.bs.js + 1 modules
var PhoneField_bs = __webpack_require__(37595);
// EXTERNAL MODULE: ./node_modules/@rescript/std/lib/es6/belt_Option.js
var belt_Option = __webpack_require__(72491);
// EXTERNAL MODULE: ./src/utils/FormHelpers.bs.js
var FormHelpers_bs = __webpack_require__(43243);
// EXTERNAL MODULE: ./src/utils/FormReducer.bs.js
var FormReducer_bs = __webpack_require__(40367);
// EXTERNAL MODULE: ./src/components/library/Notification.bs.js
var Notification_bs = __webpack_require__(88767);
// EXTERNAL MODULE: ./src/bindings/ReactHookForm.bs.js
var ReactHookForm_bs = __webpack_require__(77103);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.js
var index_esm = __webpack_require__(42283);
// EXTERNAL MODULE: ./src/layouts/OnboardingLayout.bs.js
var OnboardingLayout_bs = __webpack_require__(8103);
// EXTERNAL MODULE: ./src/api/PrezzeeSecureClient.bs.js + 12 modules
var PrezzeeSecureClient_bs = __webpack_require__(91580);
;// CONCATENATED MODULE: ./src/components/pages/forgotEmailAddress/ForgotEmailOnboardingStyles.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE
var mainContainer = "w-full max-w-md mt-24 mx-auto px-4";
var titleStyle = "text-3xl sm:text-40px text-dark-gray text-center lg:text-left mb-4";
var subtitleStyle = "sm:text-xl text-dark-gray text-center lg:text-left pb-8";
var notificationContainer = "pt-4 clear-both";
var formInput = "appearance-none rounded-lg border-2 w-full text-gray-800 leading-tight py-3 px-3 mb-4 outline-none";
var formLabel = "block text-gray-800 text-xl font-bold my-8 text-left";
var phoneInputStyle = "container mx-auto text-left";
var dropdownStyle = "text-left rounded-lg border-2";
var buttonStyle = "text-left rounded-lg border-2";
var submitBtnStyle = "mx-auto mt-6 w-40 h-12";
var errorTextStyle = "block text-xs text-left mb-2 text-prezzee-red";
 /* No side effect */ 

// EXTERNAL MODULE: ./src/components/library/OnboardingLayoutCreateAccountButton.bs.js
var OnboardingLayoutCreateAccountButton_bs = __webpack_require__(38099);
;// CONCATENATED MODULE: ./src/components/pages/forgotEmailAddress/ForgotEmailOnboarding.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE


















function ForgotEmailOnboarding(props) {
    var match = FormReducer_bs/* useFormReducer */.BZ(undefined);
    var dispatch = match[1];
    var state = match[0];
    var form = ReactHookForm_bs/* useForm */.cI({
        mode: "onSubmit",
        reValidateMode: "onSubmit",
        defaultValues: {
            phoneNumber: null
        }
    }, undefined);
    var phoneControllerOptions = FormHelpers_bs/* getPhoneControllerOptions */.V8(form.control, "phoneNumber", true);
    var match$1 = index_esm/* useController */.bc(phoneControllerOptions);
    var match$2 = match$1.field;
    var phoneError = FormHelpers_bs/* getPhoneError */.WP(form.errors, match$2.value);
    var match$3 = react.useState(function() {
        return true;
    });
    var setCanSubmit = match$3[1];
    var onSubmit = react.useCallback(function(data) {
        var phone = FormHelpers_bs/* getPhoneNumber */.ly(data.phoneNumber);
        curry._1(dispatch, /* Submit */ 0);
        curry._1(setCanSubmit, function(param) {
            return false;
        });
        setTimeout(function(param) {
            curry._1(setCanSubmit, function(param) {
                return true;
            });
        }, 60000);
        js_promise/* then_ */.k(function(result) {
            var tmp;
            if (result.TAG === /* Ok */ 0) {
                tmp = curry._1(dispatch, /* Error */ {
                    _0: {
                        TAG: /* ShowNotificationSuccess */ 0,
                        _0: "Request successful",
                        _1: "An SMS with your email address has been sent to the mobile number attached to your account."
                    }
                });
            } else {
                var e = result._0;
                curry._1(setCanSubmit, function(param) {
                    return true;
                });
                switch(e.TAG | 0){
                    case /* NetworkError */ 0:
                    case /* JsonParsingError */ 1:
                        tmp = curry._1(dispatch, /* Error */ {
                            _0: /* ShowNotificationError */ 0
                        });
                        break;
                    case /* ServerError */ 2:
                        var serverError = e._0;
                        tmp = typeof serverError === "number" || serverError.TAG !== /* ServerValidationError */ 0 ? curry._1(dispatch, /* Error */ {
                            _0: /* ShowNotificationError */ 0
                        }) : curry._1(dispatch, /* Error */ {
                            _0: {
                                TAG: /* ShowPhoneNumberError */ 1,
                                _0: serverError._0
                            }
                        });
                        break;
                }
            }
            return Promise.resolve(tmp);
        }, PrezzeeSecureClient_bs/* forgotEmailAddress */.ge(phone));
    }, []);
    var notification = state.error;
    var tmp;
    tmp = notification !== undefined ? typeof notification === "number" ? jsx_runtime.jsx(Notification_bs.make, {
        notificationType: /* NotificationError */ 0,
        title: "An error occured",
        description: "We could not send you an SMS to complete your request. Please try again later."
    }) : notification.TAG === /* ShowNotificationSuccess */ 0 ? jsx_runtime.jsx(Notification_bs.make, {
        notificationType: /* NotificationSuccess */ 2,
        title: notification._0,
        description: notification._1
    }) : jsx_runtime.jsx(Notification_bs.make, {
        notificationType: /* NotificationError */ 0,
        title: "Invalid phone number",
        description: notification._0
    }) : null;
    return jsx_runtime.jsxs(OnboardingLayout_bs/* make */.S, {
        children: [
            jsx_runtime.jsx(OnboardingLayoutCreateAccountButton_bs/* make */.S, {}),
            jsx_runtime.jsx("div", {
                children: tmp,
                className: notificationContainer
            }),
            jsx_runtime.jsxs("div", {
                children: [
                    jsx_runtime.jsx("h1", {
                        children: util_bs/* ReactStuff.s */.p_.s("Forgot your email?"),
                        className: titleStyle
                    }),
                    jsx_runtime.jsx("h2", {
                        children: util_bs/* ReactStuff.s */.p_.s("Please enter the mobile number associated with your account."),
                        className: subtitleStyle
                    }),
                    jsx_runtime.jsxs("form", {
                        children: [
                            jsx_runtime.jsx("div", {
                                children: jsx_runtime.jsx(PhoneField_bs/* TSXComponent.make */.F.make, {
                                    error: belt_Option/* getWithDefault */.tj(phoneError, ""),
                                    fieldOnChange: match$2.onChange
                                }),
                                className: "text-left"
                            }),
                            jsx_runtime.jsx("button", {
                                children: util_bs/* ReactStuff.s */.p_.s("Send me a code"),
                                className: Cn_bs/* make */.S([
                                    submitBtnStyle,
                                    match$3[0] && !state.isSubmitting ? Button_bs/* primaryStyle */.vP : Button_bs/* disabled */.JU
                                ]),
                                disabled: state.isSubmitting,
                                type: "submit"
                            })
                        ],
                        onSubmit: curry._2(form.handleSubmit, onSubmit, FormHelpers_bs/* onError */.qQ)
                    })
                ],
                className: mainContainer
            })
        ],
        onboardingKind: /* ShowAppDownload */ 1
    });
}
var Link;
var make = ForgotEmailOnboarding;
var $$default = (/* unused pure expression or super */ null && (ForgotEmailOnboarding));
 /* Util Not a pure module */ 

;// CONCATENATED MODULE: ./src/components/pages/forgotEmailAddress/ForgotEmailAddress.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE





function ForgotEmailAddress(props) {
    return jsx_runtime.jsx(make, {});
}
function getServerSideProps(param) {
    if (Belt_Option.isNone(Js_dict.get(param.query, "preview"))) {
        param.res.setHeader("Cache-Control", Constants.ssr_page_cache);
    }
    return {
        props: {}
    };
}
var ForgotEmailAddress_bs_make = ForgotEmailAddress;
var ForgotEmailAddress_bs_$$default = (/* unused pure expression or super */ null && (ForgotEmailAddress));
 /* react/jsx-runtime Not a pure module */ 

;// CONCATENATED MODULE: ./src/pages/forgot-email-address.js
__webpack_require__(14473);

var __N_SSP = true;



/***/ }),

/***/ 35070:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M2": function() { return /* binding */ toPhoneInputFormat; },
/* harmony export */   "mY": function() { return /* binding */ getCountryFromNumber; },
/* harmony export */   "n6": function() { return /* binding */ validateMobileNumber; }
/* harmony export */ });
/* harmony import */ var libphonenumber_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(58805);
/* harmony import */ var libphonenumber_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6898);



var validateMobileNumber = function(countryCode, mobileNumber) {
    if (!mobileNumber || !mobileNumber.trim()) {
        return true;
    }
    return (0,libphonenumber_js__WEBPACK_IMPORTED_MODULE_0__/* .isValidPhoneNumber */ .y)(mobileNumber.replaceAll(/\s/g, ""));
};
var defaultPhoneInputValue = {
    countryCode: ("GB" || 0).toLocaleLowerCase(),
    number: ""
};
var getCountryFromNumber = function(number) {
    return (0,libphonenumber_js__WEBPACK_IMPORTED_MODULE_1__/* .parsePhoneNumber */ .S)(number);
};
var toPhoneInputFormat = function(number) {
    if (!number || !number.trim()) {
        return defaultPhoneInputValue;
    }
    var res = (0,libphonenumber_js__WEBPACK_IMPORTED_MODULE_1__/* .parsePhoneNumber */ .S)(number, {
        extract: false
    });
    if (!res) {
        return defaultPhoneInputValue;
    }
    return {
        countryCode: (res.country || "").toLocaleLowerCase(),
        number: res.number
    };
};


/***/ }),

/***/ 37595:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "F": function() { return /* binding */ TSXComponent; }
});

// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/libphonenumber-js/min/exports/parsePhoneNumber.js + 1 modules
var exports_parsePhoneNumber = __webpack_require__(58805);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon-ui/lib/components/FormInputPhoneNumber/index.js
var FormInputPhoneNumber = __webpack_require__(22769);
// EXTERNAL MODULE: ./src/common/util.ts + 3 modules
var util = __webpack_require__(42358);
// EXTERNAL MODULE: ./src/bindings/phoneNumberUtils.js
var phoneNumberUtils = __webpack_require__(35070);
;// CONCATENATED MODULE: ./src/components/forms/PhoneField.tsx






var PhoneField = function(param) {
    var defaultCountry = param.defaultCountry, defaultNumber = param.defaultNumber, disabled = param.disabled, error = param.error, fieldOnBlur = param.fieldOnBlur, fieldOnChange = param.fieldOnChange, _mobileOnly = param.mobileOnly, mobileOnly = _mobileOnly === void 0 ? true : _mobileOnly;
    var ref;
    var ref1 = (0,react.useState)(function() {
        if (defaultNumber) return (0,exports_parsePhoneNumber/* parsePhoneNumber */.S)(defaultNumber);
        return null;
    }), phoneNumber = ref1[0], setPhoneNumber = ref1[1];
    var ref2 = (0,react.useState)(false), hasUserInput = ref2[0], setHasUserInput = ref2[1];
    var ref3 = (0,react.useState)(""), placeholderNumber = ref3[0], setPlaceholderNumber = ref3[1];
    var inputCountry = (defaultCountry === null || defaultCountry === void 0 ? void 0 : defaultCountry.toUpperCase()) || util/* envUtil.getCountry */.vK.getCountry();
    var countryCode = "AU";
    switch(inputCountry){
        case util/* COUNTRY.UnitedStates */.si.UnitedStates:
            countryCode = "US";
            break;
        case util/* COUNTRY.GreatBritain */.si.GreatBritain:
            countryCode = "GB";
            break;
        case util/* COUNTRY.NewZealand */.si.NewZealand:
            countryCode = "NZ";
            break;
    }
    var reset = function() {
        setHasUserInput(false);
        setPlaceholderNumber("");
        setPhoneNumber(null);
    };
    var parsePhoneNumber = (0,react.useCallback)(function() {
        if (!phoneNumber) {
            if (placeholderNumber) {
                return {
                    number: placeholderNumber,
                    countryCode: ""
                };
            }
            return null;
        }
        var country = phoneNumber.country, number = phoneNumber.number;
        if (country && number) {
            var isValidNumber = mobileOnly ? (0,phoneNumberUtils/* validateMobileNumber */.n6)(country, number) : true;
            if (isValidNumber) {
                return {
                    countryCode: country,
                    number: number
                };
            }
        } else if (hasUserInput) {
            return {
                number: number !== null && number !== void 0 ? number : placeholderNumber,
                countryCode: country !== null && country !== void 0 ? country : ""
            };
        } else {
            return null;
        }
    }, [
        hasUserInput,
        phoneNumber,
        placeholderNumber
    ]);
    var blurHandler = function() {
        fieldOnBlur === null || fieldOnBlur === void 0 ? void 0 : fieldOnBlur(parsePhoneNumber());
    };
    var changeHandler = function() {
        var value = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
        var codeAndNumber = value.split(" ");
        if (codeAndNumber.length < 2) {
            // only has country code from dropdown
            reset();
        } else {
            setHasUserInput(true);
            setPlaceholderNumber(codeAndNumber[1].replace(/\s/g, ""));
            var ref;
            setPhoneNumber((ref = (0,exports_parsePhoneNumber/* parsePhoneNumber */.S)(value)) !== null && ref !== void 0 ? ref : null);
        }
    };
    (0,react.useEffect)(function() {
        fieldOnChange(parsePhoneNumber());
    }, [
        hasUserInput,
        phoneNumber,
        placeholderNumber
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(FormInputPhoneNumber/* default */.Z, {
        defaultCountry: countryCode,
        defaultNumber: phoneNumber === null || phoneNumber === void 0 ? void 0 : (ref = phoneNumber.number) === null || ref === void 0 ? void 0 : ref.toString(),
        disabled: disabled,
        countryCodes: "all",
        errorMessage: error,
        onBlur: blurHandler,
        onChange: changeHandler
    });
};
/* harmony default export */ var forms_PhoneField = (PhoneField);

;// CONCATENATED MODULE: ./src/components/forms/PhoneField.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE

var make = forms_PhoneField;
var TSXComponent = {
    make: make
};
 /* make Not a pure module */ 


/***/ }),

/***/ 75897:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ make; }
/* harmony export */ });
/* unused harmony export Link */
/* harmony import */ var _common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7667);
/* harmony import */ var _rescript_std_lib_es6_string_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99813);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(72491);
/* harmony import */ var _StaticImage_bs_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(30369);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85893);
// Generated by ReScript, PLEASE EDIT WITH CARE






function DownloadAppleApp(props) {
    var baseHref = "https://itunes.apple.com/au/app/prezzee/id1047060902";
    var country = _common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .EnvUtil.currentCountry */ .i3.currentCountry;
    var href;
    href = country.TAG === /* Ok */ 0 ? baseHref.replace("au", _rescript_std_lib_es6_string_js__WEBPACK_IMPORTED_MODULE_1__/* .lowercase_ascii */ .uq(_common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .EnvUtil.getCountryCode */ .i3.getCountryCode(country._0))) : baseHref;
    return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
        href: href,
        prefetch: false,
        children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx("a", {
            children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx(_StaticImage_bs_js__WEBPACK_IMPORTED_MODULE_3__/* .make */ .S, {
                src: "/images/badge_apple_store.svg",
                alt: "Download on the App Store Logo",
                width: 125,
                height: 37,
                className: "w-full ml-1"
            }),
            className: _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_5__/* .getWithDefault */ .tj(props.className, "")
        })
    });
}
var Link$1;
var make = DownloadAppleApp;
 /* Util Not a pure module */ 


/***/ }),

/***/ 59195:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ make; }
/* harmony export */ });
/* unused harmony export Link */
/* harmony import */ var _common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7667);
/* harmony import */ var _rescript_std_lib_es6_string_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99813);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(72491);
/* harmony import */ var _StaticImage_bs_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(30369);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85893);
// Generated by ReScript, PLEASE EDIT WITH CARE






function DownloadGoogleApp(props) {
    var baseHref = "https://play.google.com/store/apps/details?id=com.prezzee.prezzee";
    var country = _common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .EnvUtil.currentCountry */ .i3.currentCountry;
    var href;
    href = country.TAG === /* Ok */ 0 ? baseHref + ("&gl=" + _rescript_std_lib_es6_string_js__WEBPACK_IMPORTED_MODULE_1__/* .lowercase_ascii */ .uq(_common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .EnvUtil.getCountryCode */ .i3.getCountryCode(country._0))) : baseHref;
    return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
        href: href,
        prefetch: false,
        children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx("a", {
            children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx(_StaticImage_bs_js__WEBPACK_IMPORTED_MODULE_3__/* .make */ .S, {
                src: "/images/badge_play_store.svg",
                alt: "Download on the App Store Logo",
                width: 125,
                height: 37,
                className: "w-full mr-1"
            }),
            className: _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_5__/* .getWithDefault */ .tj(props.className, "")
        })
    });
}
var Link$1;
var make = DownloadGoogleApp;
 /* Util Not a pure module */ 


/***/ }),

/***/ 88767:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "make": function() { return /* binding */ make; }
/* harmony export */ });
/* harmony import */ var rescript_classnames_src_Cn_bs_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(20859);
/* harmony import */ var _common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7667);
/* harmony import */ var _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(72491);
/* harmony import */ var _rescript_std_lib_es6_caml_option_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(25400);
/* harmony import */ var react_markdown__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(31758);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _NotificationStyles_bs_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(71434);
// Generated by ReScript, PLEASE EDIT WITH CARE







function $$Notification(props) {
    var notificationType = props.notificationType;
    return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx("div", {
        children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs("div", {
            children: [
                react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx("div", {
                    children: _NotificationStyles_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .icon */ .qv(notificationType)
                }),
                react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs("div", {
                    children: [
                        _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_3__/* .mapWithDefault */ .k7(props.title, null, function(title) {
                            return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx("p", {
                                children: _common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .ReactStuff.s */ .p_.s(title),
                                className: _NotificationStyles_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .titleStyle */ .E3
                            });
                        }),
                        react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx("p", {
                            children: _common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .ReactStuff.s */ .p_.s(props.description),
                            className: _NotificationStyles_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .descriptionStyle */ .ab
                        }),
                        _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_3__/* .mapWithDefault */ .k7(props.markdown, null, function(m) {
                            return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx(react_markdown__WEBPACK_IMPORTED_MODULE_4__/* .ReactMarkdown */ .D, {
                                children: _rescript_std_lib_es6_caml_option_js__WEBPACK_IMPORTED_MODULE_5__/* .some */ .G(_common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .ReactStuff.s */ .p_.s(m))
                            });
                        })
                    ]
                })
            ],
            className: _NotificationStyles_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .innerContainer */ .OM
        }),
        className: rescript_classnames_src_Cn_bs_js__WEBPACK_IMPORTED_MODULE_6__/* .make */ .S([
            _NotificationStyles_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .rootContainer */ .$2(notificationType),
            _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_3__/* .getWithDefault */ .tj(props.className, "")
        ]),
        role: "alert"
    });
}
var make = $$Notification;
 /* Util Not a pure module */ 


/***/ }),

/***/ 71434:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$2": function() { return /* binding */ rootContainer; },
/* harmony export */   "E3": function() { return /* binding */ titleStyle; },
/* harmony export */   "OM": function() { return /* binding */ innerContainer; },
/* harmony export */   "ab": function() { return /* binding */ descriptionStyle; },
/* harmony export */   "qv": function() { return /* binding */ icon; }
/* harmony export */ });
/* unused harmony exports container, notificationStyle */
/* harmony import */ var rescript_classnames_src_Cn_bs_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(20859);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
// Generated by ReScript, PLEASE EDIT WITH CARE


var container = "rounded-lg px-4 py-5 max-w-3xl text-left mx-auto";
var notificationStyle = "fill-current h-6 w-6 mr-4";
function rootContainer(notificationType) {
    switch(notificationType){
        case /* NotificationError */ 0:
            return rescript_classnames_src_Cn_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .make */ .S([
                container,
                "bg-error-pink"
            ]);
        case /* NotificationInfo */ 1:
            return rescript_classnames_src_Cn_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .make */ .S([
                container,
                "bg-info-blue"
            ]);
        case /* NotificationSuccess */ 2:
            return rescript_classnames_src_Cn_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .make */ .S([
                container,
                "bg-success-green"
            ]);
        case /* NotificationWarning */ 3:
            return rescript_classnames_src_Cn_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .make */ .S([
                container,
                "bg-warning-orange"
            ]);
    }
}
function icon(notificationType) {
    switch(notificationType){
        case /* NotificationError */ 0:
            return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs("svg", {
                children: [
                    react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx("mask", {
                        children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx("path", {
                            d: "M15 0C6.75 0 0 6.75 0 15C0 23.25 6.75 30 15 30C23.25 30 30 23.25 30 15C30 6.75 23.25 0 15 0ZM22.3477 20.25L20.25 22.3477L15 17.0977L9.75 22.3477L7.65234 20.25L12.9023 15L7.65234 9.75L9.75 7.65234L15 12.9023L20.25 7.65234L22.3477 9.75L17.0977 15L22.3477 20.25Z",
                            fill: "white"
                        }),
                        id: "mask0",
                        height: "30",
                        width: "30",
                        maskUnits: "userSpaceOnUse",
                        x: "0",
                        y: "0"
                    }),
                    react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx("g", {
                        children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx("path", {
                            d: "M15 0C6.75 0 0 6.75 0 15C0 23.25 6.75 30 15 30C23.25 30 30 23.25 30 15C30 6.75 23.25 0 15 0ZM22.3477 20.25L20.25 22.3477L15 17.0977L9.75 22.3477L7.65234 20.25L12.9023 15L7.65234 9.75L9.75 7.65234L15 12.9023L20.25 7.65234L22.3477 9.75L17.0977 15L22.3477 20.25Z",
                            fill: "#C20D16"
                        }),
                        mask: "url(#mask0)"
                    })
                ],
                className: notificationStyle,
                height: "30",
                width: "30",
                viewBox: "0 0 30 30",
                xmlns: "http://www.w3.org/2000/svg"
            });
        case /* NotificationInfo */ 1:
            return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx("svg", {
                children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx("path", {
                    clipRule: "evenodd",
                    d: "M15 30C18.9781 30 22.7931 28.4192 25.6066 25.6066C28.4191 22.7928 30 18.9781 30 15C30 11.0219 28.4192 7.20687 25.6066 4.39344C22.7928 1.58094 18.9781 0 15 0C11.0219 0 7.20687 1.58081 4.39344 4.39344C1.58094 7.20716 0 11.0219 0 15C0 18.9781 1.58081 22.7931 4.39344 25.6066C7.20716 28.4191 11.0219 30 15 30ZM15 6.5625C15.7581 6.5625 16.4417 7.01903 16.7322 7.71972C17.0227 8.42041 16.8616 9.22728 16.3257 9.76319C15.7898 10.2991 14.9829 10.4602 14.2822 10.1697C13.5815 9.87916 13.125 9.19556 13.125 8.4375C13.125 7.40234 13.9648 6.5625 15 6.5625ZM13.125 13.125L16.875 13.125V23.4375H13.125L13.125 13.125Z",
                    fill: "#2E5299",
                    fillRule: "evenodd"
                }),
                className: notificationStyle,
                height: "30",
                width: "30",
                viewBox: "0 0 30 30",
                xmlns: "http://www.w3.org/2000/svg"
            });
        case /* NotificationSuccess */ 2:
            return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx("svg", {
                children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx("path", {
                    clipRule: "evenodd",
                    d: "M15 0C23.2843 0 30 6.71573 30 15C30 23.2843 23.2843 30 15 30C6.71573 30 0 23.2843 0 15C0 6.71573 6.71573 0 15 0ZM20.7973 9L12.8003 16.9949L9.10428 13.6131L7 15.9122L12.8957 21.3069L23 11.2027L20.7973 9Z",
                    fill: "#25AE88",
                    fillRule: "evenodd"
                }),
                className: notificationStyle,
                height: "30",
                width: "30",
                viewBox: "0 0 30 30",
                xmlns: "http://www.w3.org/2000/svg"
            });
        case /* NotificationWarning */ 3:
            return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx("svg", {
                children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx("path", {
                    clipRule: "evenodd",
                    d: "M15 0C11.0219 0 7.20688 1.58081 4.39344 4.39344C1.58094 7.20716 0 11.0219 0 15C0 18.9781 1.58081 22.7931 4.39344 25.6066C7.20716 28.4191 11.0219 30 15 30C18.9781 30 22.7931 28.4192 25.6066 25.6066C28.4191 22.7928 30 18.9781 30 15C30 11.0219 28.4192 7.20687 25.6066 4.39344C22.7928 1.58094 18.9781 0 15 0ZM15 23.4375C14.2419 23.4375 13.5583 22.981 13.2678 22.2803C12.9773 21.5796 13.1384 20.7727 13.6743 20.2368C14.2102 19.7009 15.0171 19.5398 15.7178 19.8303C16.4185 20.1208 16.875 20.8044 16.875 21.5625C16.875 22.5977 16.0352 23.4375 15 23.4375ZM16.875 16.875H13.125V6.5625H16.875V16.875Z",
                    fill: "#DC5800",
                    fillRule: "evenodd"
                }),
                className: rescript_classnames_src_Cn_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .make */ .S([
                    notificationStyle,
                    "text-teal-500"
                ]),
                height: "30",
                width: "30",
                viewBox: "0 0 30 30",
                xmlns: "http://www.w3.org/2000/svg"
            });
    }
}
var innerContainer = "flex";
var titleStyle = "font-bold text-lg text-dark-gray pb-1";
var descriptionStyle = "text-base text-dark-gray";
 /* react/jsx-runtime Not a pure module */ 


/***/ }),

/***/ 38099:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ make; }
/* harmony export */ });
/* unused harmony export Link */
/* harmony import */ var rescript_classnames_src_Cn_bs_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(20859);
/* harmony import */ var _common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7667);
/* harmony import */ var _Button_bs_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59037);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);
// Generated by ReScript, PLEASE EDIT WITH CARE





function OnboardingLayoutCreateAccountButton(props) {
    return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs("div", {
        children: [
            react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx("p", {
                children: _common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .ReactStuff.s */ .p_.s("Not registered?"),
                className: "text-light-gray text-sm mr-6"
            }),
            react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                href: "/register",
                prefetch: false,
                children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx("button", {
                    children: _common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .ReactStuff.s */ .p_.s("Create an account"),
                    "aria-label": "Register",
                    className: rescript_classnames_src_Cn_bs_js__WEBPACK_IMPORTED_MODULE_4__/* .make */ .S([
                        "w-40 h-12 ml-1",
                        _Button_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .primaryOutlineStyle */ .e1
                    ]),
                    type: "button"
                })
            })
        ],
        className: "flex items-center float-right mr-4 lg:mr-10"
    });
}
var Link$1;
var make = OnboardingLayoutCreateAccountButton;
 /* Util Not a pure module */ 


/***/ }),

/***/ 8103:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ make; }
/* harmony export */ });
/* unused harmony export features */
/* harmony import */ var _common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7667);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _rescript_std_lib_es6_belt_Array_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(96533);
/* harmony import */ var _components_StaticImage_bs_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(30369);
/* harmony import */ var _components_library_DownloadAppleApp_bs_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(75897);
/* harmony import */ var _components_library_DownloadGoogleApp_bs_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(59195);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(85893);
// Generated by ReScript, PLEASE EDIT WITH CARE







var features = [
    "Keep all my eGift cards in one place",
    "Fast access from my phone while I shop",
    "Secure digital wallet",
    "Get offers",
    "Send gift cards even faster"
];
var make = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.memo(function(props) {
    var onboardingKind = props.onboardingKind;
    var match = _common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .EnvUtil.currentCountry */ .i3.currentCountry;
    var deviseImg;
    deviseImg = match.TAG === /* Ok */ 0 && match._0 === 3 ? {
        width: 448,
        height: 265,
        src: "/images/laptop_wallet.png",
        alt: "Prezzee wallet"
    } : {
        width: 448,
        height: 275,
        src: "/images/prezzee_desktop_wallet.png",
        alt: "Prezzee wallet"
    };
    return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs("div", {
        children: [
            react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx("div", {
                children: typeof onboardingKind === "number" ? onboardingKind !== 0 ? react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs("div", {
                    children: [
                        react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs("div", {
                            children: [
                                react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs("h2", {
                                    children: [
                                        _common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .ReactStuff.s */ .p_.s("Never forget a"),
                                        react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx("br", {}),
                                        _common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .ReactStuff.s */ .p_.s("gift card again.")
                                    ],
                                    className: "font-semibold text-3xl text-white mb-4 "
                                }),
                                react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs("p", {
                                    children: [
                                        react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx("strong", {
                                            children: _common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .ReactStuff.s */ .p_.s("Buy, send and store ")
                                        }),
                                        _common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .ReactStuff.s */ .p_.s("gift cards, all"),
                                        react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx("br", {}),
                                        _common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .ReactStuff.s */ .p_.s("with a few clicks in the Prezzee App."),
                                        react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx("br", {}),
                                        react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx("strong", {
                                            children: _common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .ReactStuff.s */ .p_.s("Download for free now.")
                                        })
                                    ],
                                    className: "text-lg text-white font-thin leading-relaxed mb-8"
                                }),
                                react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs("div", {
                                    children: [
                                        react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx(_components_library_DownloadGoogleApp_bs_js__WEBPACK_IMPORTED_MODULE_4__/* .make */ .S, {
                                            className: "mr-3 w-32"
                                        }),
                                        react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx(_components_library_DownloadAppleApp_bs_js__WEBPACK_IMPORTED_MODULE_3__/* .make */ .S, {
                                            className: "ml-3 w-32"
                                        })
                                    ],
                                    className: "flex"
                                })
                            ],
                            className: ""
                        }),
                        react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx("div", {
                            children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx(_components_StaticImage_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .make */ .S, {
                                src: "/images/prezzee_mobile_app.png",
                                alt: "Prezzee iOS and Android mobile applications",
                                width: 448,
                                height: 457,
                                className: "max-w-md w-full h-auto py-6 my-auto"
                            }),
                            className: "flex-grow flex"
                        })
                    ],
                    className: "px-2 xl:px-10 xxl:px-16 flex flex-col flex-grow"
                }) : react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs("div", {
                    children: [
                        react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx("ul", {
                            children: _common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .ReactStuff.ate */ .p_.ate(_rescript_std_lib_es6_belt_Array_js__WEBPACK_IMPORTED_MODULE_6__/* .mapWithIndex */ .Su(features, function(index, feature) {
                                return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs("li", {
                                    children: [
                                        react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx("div", {
                                            children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx(_components_StaticImage_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .make */ .S, {
                                                src: "/images/icon_tick.svg",
                                                alt: feature,
                                                width: 20,
                                                height: 20
                                            }),
                                            className: "mt-1 mr-4"
                                        }),
                                        react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx("span", {
                                            children: _common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .ReactStuff.s */ .p_.s(feature),
                                            className: "block w-full max-w-xs"
                                        })
                                    ],
                                    className: "flex mb-8"
                                }, "index-" + String(index));
                            })),
                            className: "flex-grow text-white text-xl"
                        }),
                        react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx(_components_StaticImage_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .make */ .S, {
                            src: deviseImg.src,
                            alt: deviseImg.alt,
                            width: deviseImg.width,
                            height: deviseImg.height,
                            className: "max-w-md w-full h-auto py-6 mt-auto"
                        })
                    ],
                    className: "px-2 xl:px-10 xxl:px-16 flex flex-col flex-grow"
                }) : react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs("div", {
                    children: [
                        _rescript_std_lib_es6_belt_Array_js__WEBPACK_IMPORTED_MODULE_6__/* .mapWithIndex */ .Su(onboardingKind._0, function(i, text) {
                            return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx("h2", {
                                children: _common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .ReactStuff.s */ .p_.s(text),
                                className: "font-bold text-4xl text-white text-center"
                            }, "title" + String(i));
                        }),
                        react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx(_components_StaticImage_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .make */ .S, {
                            src: "/images/presents.svg",
                            alt: "Presents",
                            width: 518,
                            height: 303,
                            className: "w-full pt-20 flex-grow"
                        })
                    ]
                }),
                className: "hidden w-full lg:flex flex-col lg:w-1/3 py-20 pb-5 px-5 bg-prezzee-red"
            }),
            react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx("div", {
                children: props.children,
                className: "w-full lg:w-2/3 bg-white text-center py-5"
            })
        ],
        className: "flex flex-wrap-reverse w-full"
    });
});
 /* make Not a pure module */ 


/***/ }),

/***/ 40367:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BZ": function() { return /* binding */ useFormReducer; }
/* harmony export */ });
/* unused harmony exports initialState, reducer */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _rescript_std_lib_es6_caml_option_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25400);
// Generated by ReScript, PLEASE EDIT WITH CARE


var initialState = {
    isSubmitting: false,
    error: undefined
};
function reducer(param, action) {
    if (typeof action === "number") {
        if (action !== 0) {
            return initialState;
        } else {
            return {
                isSubmitting: true,
                error: undefined
            };
        }
    } else {
        return {
            isSubmitting: false,
            error: _rescript_std_lib_es6_caml_option_js__WEBPACK_IMPORTED_MODULE_1__/* .some */ .G(action._0)
        };
    }
}
function useFormReducer(param) {
    return react__WEBPACK_IMPORTED_MODULE_0__.useReducer(reducer, initialState);
}
 /* react Not a pure module */ 


/***/ }),

/***/ 6898:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "y": function() { return /* binding */ isValidPhoneNumber_isValidPhoneNumber; }
});

// EXTERNAL MODULE: ./node_modules/libphonenumber-js/min/exports/withMetadataArgument.js + 1 modules
var withMetadataArgument = __webpack_require__(99583);
// EXTERNAL MODULE: ./node_modules/libphonenumber-js/es6/normalizeArguments.js
var normalizeArguments = __webpack_require__(55178);
// EXTERNAL MODULE: ./node_modules/libphonenumber-js/es6/parsePhoneNumber_.js + 33 modules
var parsePhoneNumber_ = __webpack_require__(69623);
;// CONCATENATED MODULE: ./node_modules/libphonenumber-js/es6/isValidPhoneNumber.js
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



function isValidPhoneNumber() {
  var _normalizeArguments = (0,normalizeArguments/* default */.Z)(arguments),
      text = _normalizeArguments.text,
      options = _normalizeArguments.options,
      metadata = _normalizeArguments.metadata;

  options = _objectSpread(_objectSpread({}, options), {}, {
    extract: false
  });
  var phoneNumber = (0,parsePhoneNumber_/* default */.Z)(text, options, metadata);
  return phoneNumber && phoneNumber.isValid() || false;
}
//# sourceMappingURL=isValidPhoneNumber.js.map
;// CONCATENATED MODULE: ./node_modules/libphonenumber-js/min/exports/isValidPhoneNumber.js



function isValidPhoneNumber_isValidPhoneNumber() {
	return (0,withMetadataArgument/* default */.Z)(isValidPhoneNumber, arguments)
}

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1758,8137,7342,2769,8805,1580,9774,2888,179], function() { return __webpack_exec__(41087); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);